export const COPY_SUCCESS_ICON = 'clipboard-checked';
export const COPY_ACTION_ICON = 'clipboard-copy';
